const actions = {
	SET_PAYCHECK: "SET_PAYCHECK"
};

export default actions;
